import { render, staticRenderFns } from "./SelectsPresetsControl.vue?vue&type=template&id=5fb966c7&scoped=true&lang=pug"
import script from "./SelectsPresetsControl.vue?vue&type=script&lang=js"
export * from "./SelectsPresetsControl.vue?vue&type=script&lang=js"
import style0 from "./SelectsPresetsControl.vue?vue&type=style&index=0&id=5fb966c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb966c7",
  null
  
)

export default component.exports